import SearchBar from "./SearchBar";
import RecentPosts from "./RecentPosts";
import CategoryList from "./CategoryList";

import styles from "../styles/sidebar/Sidebar.module.css";


import type { Dispatch, SetStateAction } from "react";
import  servicesData  from "../../constants/servicesData";


type SidebarProps = {
  searchTerm?: string;
  onSearchChange?: Dispatch<SetStateAction<string>>;
};

const Sidebar = ({
  searchTerm = "",
  onSearchChange = () => {},
}: SidebarProps) => {
  const serviceItems: { id?: string; heading: string }[] = Array.isArray(servicesData)
    ? servicesData
    : (servicesData?.services ?? []);

  const allCategories = serviceItems.map((service) => ({
    heading: service.heading,
    id: `/${service.id}`,
    // link: service.link,
  }));

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarContent}>
        <SearchBar searchTerm={searchTerm} onSearchChange={onSearchChange} />
        <RecentPosts />
        <CategoryList heading={"Services"} categories={allCategories} />
      </div>
    </aside>
  );
};

export default Sidebar;
